import React, { FC, useState, useContext } from 'react';

const ColorRampContext = React.createContext<null | any>(null);
const ColorRampProvider: FC = ({ children }) => {
  const [themeType, setThemeType] = useState('light_theme');
  const [showContrast, setShowContrast] = useState<string | null>(null);
  const [rampId, setRampId] = useState<string | null>(null);

  const value: any = {
    themeType,
    setThemeType,
    showContrast,
    setShowContrast,
    rampId,
    setRampId,
  };
  return <ColorRampContext.Provider value={value}>{children}</ColorRampContext.Provider>;
};

const useColorRamp = () => {
  const ctx = useContext(ColorRampContext);
  if (ctx === undefined) {
    return;
  }
  return ctx;
};

export { ColorRampProvider, useColorRamp };
